import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdDataSourceLayoutAnalyticIds = {
  connectAccountingBtnId: string;
  connectPayrollBtnId: string;
  uploadTicketingProviderBtnId: string;
  uploadTaxDocsBtnId: string;
};

export const useRdDataSourceLayoutAnalyticIds = (): RdDataSourceLayoutAnalyticIds => ({
  connectAccountingBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_CONNECT_ACCOUNTING_BUTTON),
  connectPayrollBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_CONNECT_PAYROLL_BUTTON),
  uploadTicketingProviderBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_UPLOAD_TICKETING_PROVIDER_BUTTON),
  uploadTaxDocsBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_UPLOAD_TAX_DOCS_BUTTON),
});
